// Travelpayouts White Label configuration.
// wl_id, marker, trs, domain, locale, currency and link_color all live here.
// Swap these values when you rotate a White Label campaign.
//
// NOTE on `domain`: the TP White Label script redirects search submissions to
// this hostname when it doesn't match the current page. For same-page inline
// results, `getBookingDomain()` returns the runtime hostname so TP renders
// tickets into `#tpwl-tickets` on whatever host the booking page is served.
const STATIC_DOMAIN = "booking.jetsetless.com";

export function getBookingDomain() {
  if (typeof window !== "undefined" && window.location?.hostname) {
    return window.location.hostname;
  }
  return STATIC_DOMAIN;
}

export const TRAVELPAYOUTS = {
  WL_ID: "6541",
  MARKER: "174867",
  TRS: "434752",
  get DOMAIN() { return getBookingDomain(); },
  CURRENCY: "USD",
  LOCALE: "EN",
  LINK_COLOR: "00AFDD",
};

export const TP_SCRIPT_SRC = `https://tpwidg.com/wl_web/main.js?wl_id=${TRAVELPAYOUTS.WL_ID}`;
